import { Page } from "@/models/page-models/Page";

export const SalesContractEdit: Page = {
  "path": "edit-sales-contract/:quotationId",
  "name": "Quotation",
  "props": {
    "data": {
      "title": "Quotation",
      "arabicTitle": "عرض أسعار",
      "printable": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Open')",
      "hidePrintHeaders": "fn(NOT,fn(FEATURE_FLAG,Show Old QT Print))",
      "url": "edit-sales-contract/:quotationId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.quotation.data._id",
                  "label": "Doc ID#",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "formData.status",
                  "label": "Status",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,qtStatus,{{fetchedData.quotation.data}})",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "formData.createdAt",
                  "label": "Creation Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.createdAt}},show-time)",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "formData.updatedAt",
                  "label": "Last Updated",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.updatedAt}},show-time)",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "fetchedData.quotation.data.customer.assignedTo.displayName",
                  "label": "Salesman",
                  "printable": false
                }
              ]
            },
            {
              "name": "1 (1)",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.customer",
                  "label": "Customer",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,customerAlias,{{fetchedData.selectedCustomer}})",
                  "url": "/customers/{{formData.customer}}",
                  "printable": false,
                  "class": "pt-6"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedContact",
                  "label": "Select Contact",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copyContactData",
                      "pageFunction": {
                        "name": "copyContactData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.contact"
                      }
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.contact",
                  "itemText": "firstName",
                  "itemValue": "firstName",
                  "formula": "fn(HELPER_FN,contactName,{{__item}})",
                  "printable": false
                }
              ],
              "disabled": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))"
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedProduct",
                  "label": "Select Product",
                  "disabled": "FALSE",
                  "items": "fetchedData.filteredProducts",
                  "itemText": "productLine",
                  "itemValue": "_id",
                  "printable": false,
                  "formula": "fn(CONCAT,{{__item._id}}, ,fn(HELPER_FN,productAlias,{{__item}},true,true))",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyProductDetails",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedProductDetails"
                      },
                      "name": "copyProductDetails"
                    }
                  ]
                },
                {
                  "type": "button",
                  "label": "Add Product",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyPriceBracketFlag",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.selectedProductDetails.allowPriceBracket",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.priceBracketOnly"
                      },
                      "name": "copyPriceBracketFlag"
                    },
                    {
                      "executionOrder": 1,
                      "name": "addProduct",
                      "pageFunction": {
                        "name": "addProduct",
                        "type": "fnPushToArray",
                        "arg1Key": "sourceFn",
                        "arg1Value": "findSelectedProductDetails",
                        "arg2Key": "sourceTransformationFn",
                        "arg2Value": "transformProductForTable",
                        "arg3Key": "destinationVariable",
                        "arg3Value": "formData.items"
                      }
                    },
                    {
                      "executionOrder": 2,
                      "name": "resetSelectedProduct",
                      "pageFunction": {
                        "name": "resetSelectedProduct",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedProduct"
                      }
                    },
                    {
                      "executionOrder": 2,
                      "name": "copyFilteredProducts"
                    }
                  ],
                  "disabled": "fn(LOGICAL,fn(NOT,{{fetchedData.selectedProduct}}),||,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedProductDetails.productState}},'),==,'Expired'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedProductDetails.productState}},'),==,'Inactive')))",
                  "color": "primary",
                  "printable": false
                }
              ],
              "disabled": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))"
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "qtItemsTable",
                  "variable": "formData.items",
                  "label": "Products Table",
                  "disabled": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Open')",
                  "items": "fetchedData.products.data.docs",
                  "currentItemsVariable": "fetchedData.quotation.data.items",
                  "showIf": "{{fetchedData.products.data.docs}}",
                  "printable": false,
                  "variableKey": "product",
                  "itemKey": "_id",
                  "executeOnDelete": [
                    {
                      "executionOrder": 2,
                      "name": "copyFilteredProducts"
                    }
                  ],
                  "priceBracketVariable": "formData.priceBracketOnly"
                }
              ],
              "disabled": "fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER))"
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.termsAndConditions.deliveryLeadTime",
                  "label": "Lead Time From Order Confirmation",
                  "disabled": "FALSE",
                  "items": "fetchedData.deliveryTime.data.0.data",
                  "itemText": "display",
                  "itemValue": "value",
                  "printable": false
                }
              ],
              "disabled": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))"
            },
            {
              "name": "4a",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Terms & Conditions",
                  "printable": false,
                  "class": "text-subtitle-2"
                }
              ]
            },
            {
              "name": "offer validity row-5a",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.termsAndConditions.offerValidity",
                  "label": "Offer Validity",
                  "disabled": "FALSE",
                  "printable": false,
                  "minDateFormula": "fn(CONDITIONAL,fn(NOT,{{formData.createdAt}}),{{TODAYS_DATE}},{{formData.createdAt}})",
                  "maxDateFormula": "fn(ADD_DAYS,fn(CONDITIONAL,fn(NOT,{{formData.createdAt}}),{{TODAYS_DATE}},{{formData.createdAt}}),365)"
                },
                {
                  "type": "input",
                  "variable": "formData.termsAndConditions.contractDuration",
                  "label": "Contract Duration",
                  "unit": "days",
                  "disabled": "FALSE",
                  "printable": false
                }
              ],
              "disabled": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))"
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.termsAndConditions.tolerance",
                  "label": "Tolerance",
                  "unit": "%",
                  "disabled": "FALSE",
                  "printable": false
                },
                {
                  "type": "dropdown",
                  "variable": "formData.termsAndConditions.shippingMode",
                  "label": "Shipping Mode",
                  "disabled": "FALSE",
                  "items": "[\"Land\",\"Sea\",\"Air\"]",
                  "dropdownType": "static",
                  "printable": false
                }
              ],
              "disabled": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))"
            },
            {
              "name": "8",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.termsAndConditions.tradeTerms.type",
                  "label": "Trade Terms",
                  "disabled": "TRUE",
                  "items": "fetchedData.tradeTermsDetails.data.0.data",
                  "itemText": "en",
                  "itemValue": "type",
                  "printable": false,
                  "formula": "{{__item.en}} ({{__item.type}})"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.deliveryLocations",
                  "label": "Delivery Locations",
                  "disabled": "FALSE",
                  "items": "fetchedData.selectedCustomer.deliveryAddresses",
                  "itemText": "ref",
                  "itemValue": "ref",
                  "required": true,
                  "printable": false,
                  "multiple": true
                }
              ],
              "disabled": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))"
            },
            {
              "name": "9a",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.termsAndConditions.paymentTerms.type",
                  "label": "Payment Terms",
                  "disabled": "TRUE",
                  "items": "fetchedData.paymentTermOptions.data.0.data",
                  "itemText": "en",
                  "itemValue": "alias",
                  "formula": "{{__item.alias}} ({{__item.en}})",
                  "printable": false
                }
              ],
              "showIf": "{{formData.termsAndConditions.paymentTerms.type}}"
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Payment Terms",
                  "printable": false
                }
              ],
              "showIf": "fn(NOT,{{formData.termsAndConditions.paymentTerms.type}})"
            },
            {
              "name": "10",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.termsAndConditions.paymentTerms.advancePercent",
                  "label": "Advance %",
                  "unit": "%",
                  "disabled": "TRUE",
                  "printable": false
                },
                {
                  "type": "dropdown",
                  "variable": "formData.termsAndConditions.paymentTerms.daysAfterInvoice",
                  "label": "No of Days From Invoice Date",
                  "disabled": "TRUE",
                  "items": "fetchedData.deliveryTime.data.0.data",
                  "itemText": "display",
                  "itemValue": "value",
                  "printable": false
                }
              ],
              "showIf": "fn(NOT,{{formData.termsAndConditions.paymentTerms.type}})"
            },
            {
              "name": "11",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update QT",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "updateItemsArray",
                        "type": "fnCreateArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "formData.items",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "formData.items",
                        "arg3Key": "arrayTransformationFn",
                        "arg3Value": "getTransformedContractItem"
                      },
                      "name": "updateItemsArray"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "createSalesContract",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/quotation/insert",
                        "arg2Key": "storeResponse",
                        "arg2Value": "TRUE",
                        "arg3Key": "serviceConfig",
                        "arg3Value": "{\"service\":\"PRICE_CHANGE_REQUEST\",\"args\":[\"formData.items\",\"fetchedData.products.data.docs\", \"fetchedData.orders\"],\"destinationKey\":\"formData.items\"}"
                      },
                      "name": "createSalesContract"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "redirectToSalesContract",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/edit-sales-contract/{{__response.data._id}}"
                      },
                      "name": "redirectToSalesContract",
                      "executeIf": "fn(LOGICAL,{{__response.data._id}},>,-1)"
                    }
                  ],
                  "disabled": "fn(DEEP_EQUAL,{{formData}},{{fetchedData.initialFormData}})",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),!=,'Open')",
              "disabled": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.quotation.data.approvalVersion}},'),>,0),&&,fn(MATCH_ROLE,Accounting | Executive))"
            },
            {
              "name": "12",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Revise QT",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "reviseQt",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/quotation/{{__params.quotationId}}/revise",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                      },
                      "name": "reviseQt"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Open')",
              "disabled": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))"
            },
            {
              "name": "11a",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Submit Draft QT",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "submitDraft",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/quotation/{{__params.quotationId}}/submit-draft",
                        "arg2Key": "refreshPage",
                        "arg2Value": "TRUE"
                      },
                      "name": "submitDraft"
                    }
                  ],
                  "disabled": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Draft'),{{formData.items}},product,{{fetchedData.products.data.docs}},_id),>,0)",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Draft'),||,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Revised Draft'))",
              "disabled": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))"
            },
            {
              "name": "12",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Submit",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySubmitOrderForm",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getSubmitOrderForm",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.submitOrderForm"
                      },
                      "name": "copySubmitOrderForm"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "createSubmitSalesContractFormOrderArray",
                        "type": "fnCreateArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "fetchedData.quotation.data.items",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "fetchedData.submitOrderForm.orders",
                        "arg3Key": "arrayTransformationFn",
                        "arg3Value": "retrieveId"
                      },
                      "name": "createSubmitSalesContractFormOrderArray"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "setContractStartEndDates",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getContractStartEndDates",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.submitOrderForm.dateRange"
                      },
                      "name": "setContractStartEndDates"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "openPoProofPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Upload Proof"
                      },
                      "name": "openPoProofPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER))))",
                  "color": "secondary"
                },
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "FALSE",
                  "color": "secondary",
                  "showIf": "fn(LOGICAL,fn(FEATURE_FLAG,Show Old QT Print),&&,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))))",
                  "buttonType": "print"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Open')"
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(HELPER_FN,scEditFlag,{{formData.status}})",
          "disabled": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Quotation Expired'),||,fn(LOGICAL,fn(MATCH_ROLE,Sales | Account Executive),&&,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Submitted Draft')))"
        },
        {
          "groupItems": [
            {
              "name": "1b",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Extend",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openExtendQtPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Extend QT"
                      },
                      "name": "openExtendQtPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.quotation.data.requests}}),==,0)",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Quotation Expired')"
            },
            {
              "name": "2b",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Reject",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "openRejectionPopup",
                      "pageFunction": {
                        "name": "openRejectionPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Reject Quotation"
                      }
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.quotation.data.requests}}),==,0)",
                  "color": "error",
                  "printable": false
                }
              ]
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(LOGICAL,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))),&&,fn(HELPER_FN,scEditFlag,{{formData.status}}))"
        },
        {
          "groupItems": [
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Approve",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "approveQuotation",
                      "pageFunction": {
                        "name": "approveQuotation",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/quotation/{{__params.quotationId}}/approve",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "serviceConfig",
                        "arg4Value": "{\"service\":\"APPROVE_PRICE_CHANGE\",\"args\":[\"formData.items\"]}"
                      }
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Submitted Draft'),||,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Pending Approval'),||,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Pending Revision')))",
                  "color": "secondary",
                  "printable": false
                }
              ]
            },
            {
              "name": "2c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Confirm Reject Request",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openRejectRequestPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Confirm Reject Quotation Request"
                      },
                      "name": "openRejectRequestPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.quotation.data.requests.0.type}},'),==,'Reject')",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.quotation.data.requests}}),>,0)"
            },
            {
              "name": "3c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "View Extend Request",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openExtendQtRequest",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "View Extend Quotation Request"
                      },
                      "name": "openExtendQtRequest"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.quotation.data.requests.0.type}},'),==,'Extend Quotation')",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.quotation.data.requests}}),>,0)"
            },
          ],
          "type": "genericGroup",
          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Sales | Manager),||,fn(MATCH_ROLE,General Manager))"
        },
        {
          "type": "popupGroup",
          "label": "Confirm Reject Quotation Request",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.quotation.data.requests.0.reason",
                  "label": "Reason for rejecting",
                  "disabled": "TRUE",
                  "items": "fetchedData.qtRejectionReasons.data.0.data",
                  "itemText": "en",
                  "itemValue": "en",
                  "printable": false,
                  "multiple": true
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.quotation.data.requests.0.otherReason",
                  "label": "Please elaborate",
                  "showIf": "fn(INCLUDE_ARRAY,{{fetchedData.quotation.data.requests.0.reason}},Other)",
                  "disabled": "TRUE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Approve",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "approveReject",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/request/reject/{{fetchedData.quotation.data.requests.0._id}}/approve",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "GET"
                  },
                  "name": "approveReject"
                }
              ]
            },
            {
              "label": "Reject",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectReject",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/request/reject/{{fetchedData.quotation.data.requests.0._id}}/reject",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "requestMethod",
                    "arg3Value": "GET",
                    "arg4Key": "refreshPage",
                    "arg4Value": "TRUE"
                  },
                  "name": "rejectReject"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Reject Quotation",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.rejectionForm.rejectionReason",
                  "label": "Reason for rejecting",
                  "disabled": "FALSE",
                  "items": "fetchedData.qtRejectionReasons.data.0.data",
                  "itemText": "en",
                  "itemValue": "en",
                  "multiple": true,
                  "printable": false
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.rejectionForm.otherRejectionReason",
                  "label": "Please elaborate",
                  "showIf": "fn(INCLUDE_ARRAY,{{fetchedData.rejectionForm.rejectionReason}},Other)",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Confirm",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "rejectQoutation",
                  "pageFunction": {
                    "name": "rejectQoutation",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": " /api/v1/sales-contract/{{fetchedData.quotation.data._id}}/request/reject",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.rejectionForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  }
                },
                {
                  "executionOrder": 2,
                  "name": "closeRejectionPopup",
                  "pageFunction": {
                    "name": "closeRejectionPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Reject Quotation"
                  }
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Upload Proof",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "fetchedData.submitOrderForm.orders",
                  "label": "Orders",
                  "disabled": "FALSE",
                  "items": "fetchedData.quotation.data.items",
                  "headers": [
                    {
                      "value": "__item.product",
                      "text": "Name",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})",
                      "width": 150
                    },
                    {
                      "value": "__item.product.unit.unit2",
                      "text": "Selling Unit",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,baseUnit,{{__item.product}})"
                    },
                    {
                      "value": "__item.productPrice.price",
                      "text": "Unit Price",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.productPrice.price}})"
                    },
                    {
                      "value": "__item.totalQuantity",
                      "text": "Quantity"
                    },
                    {
                      "value": "__item.totalFOC",
                      "text": "FOC"
                    },
                    {
                      "value": "__item.value",
                      "text": "Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.productPrice.price}},{{__item.totalQuantity}}))"
                    }
                  ],
                  "tableType": "dynamic",
                  "variableKey": "product",
                  "itemKey": "product._id",
                  "canDelete": false,
                  "validationVariable": "customerPO"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.submitOrderForm.customerPO",
                  "label": "Customer PO#",
                  "disabled": "FALSE"
                },
                {
                  "type": "fileupload",
                  "variable": "fetchedData.submitOrderForm.uploadedProof",
                  "label": "PO",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "fetchedData.submitOrderForm.dateRange.startDate",
                  "label": "Start Date",
                  "disabled": "TRUE"
                },
                {
                  "type": "datepicker",
                  "variable": "fetchedData.submitOrderForm.dateRange.endDate",
                  "label": "End Date",
                  "disabled": "TRUE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "submitSalesContract",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/quotation/{{__params.quotationId}}/submit-sales-contract",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.submitOrderForm",
                    "arg3Key": "fnsAfterSubmit",
                    "arg3Value": "[{\"executionOrder\":1,\"name\":\"closePoProofPopup\"},{\"executionOrder\":2,\"name\":\"openSalesDashboard\"}]"
                  },
                  "name": "submitSalesContract"
                }
              ]
            }
          ],
          "itemVariable": "formData"
        },
        {
          "type": "popupGroup",
          "label": "Extend QT",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.termsAndConditions.offerValidity",
                  "label": "Current Offer Validity",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.termsAndConditions.offerValidity}})",
                },
                {
                  "type": "datepicker",
                  "variable": "fetchedData.extendQt.proposedOfferValidity",
                  "label": "Proposed Offer Validity",
                  "disabled": "FALSE",
                  "minDateFormula": "{{TODAYS_DATE}}",
                  "maxDateFormula": "fn(ADD_DAYS,{{TODAYS_DATE}},365)"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "extendQt",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/{{__params.quotationId}}/request/extend-quotation",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.extendQt",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "extendQt"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeExtendQt",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Extend QT"
                  },
                  "name":"closeExtendQt"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "View Extend Quotation Request",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.termsAndConditions.offerValidity",
                  "label": "Current Offer Validity",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.termsAndConditions.offerValidity}})",
                },
                {
                  "type": "label",
                  "variable": "fetchedData.quotation.data.requests.0.proposedOfferValidity",
                  "label": "Proposed Offer Validity",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{fetchedData.quotation.data.requests.0.proposedOfferValidity}})",
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Approve",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "approveExtendQt",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/request/extend/{{fetchedData.quotation.data.requests.0._id}}/approve-quotation",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "GET"
                  },
                  "name": "approveExtendQt"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeExtendQtRequestPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "View Extend Quotation Request"
                  },
                  "name":"closeExtendQtRequestPopup"
                }
              ]
            },
            {
              "label": "Reject",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectExtend",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/request/extend/{{fetchedData.quotation.data.requests.0._id}}/reject",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "requestMethod",
                    "arg3Value": "GET",
                    "arg4Key": "refreshPage",
                    "arg4Value": "TRUE"
                  },
                  "name": "rejectExtend"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeExtendQtRequestPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "View Extend Quotation Request"
                  },
                  "name":"closeExtendQtRequestPopup"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "1-printonly",
              "pageItems": [
                {
                  "type": "quotationPrintView",
                  "variable": "fetchedData.quotation.data",
                  "label": "Quotation Print Master",
                  "config": {
                    "customerDetailsVariable": "fetchedData.selectedCustomer",
                    "tradeTermsListVariable": "fetchedData.tradeTermsDetails.data.0.data",
                    "paymentTermsListVariable": "fetchedData.paymentTermOptions.data.0.data",
                    "vatPercentVariable": "fetchedData.vatPercent",
                    "companyDetailsVariable": "fetchedData.companyDetails.data.0.data"
                  }
                }
              ],
              "showIf": "fn(NOT,fn(FEATURE_FLAG,Show Old QT Print))"
            },
            {
              "name": "1-printonly",
              "pageItems": [
                {
                  "type": "custom_QuotationDetails",
                  "variable": "fetchedData.quotation.data",
                  "label": "Quotation Details",
                  "config": {
                    "customerDetailsVariable": "fetchedData.selectedCustomer"
                  },
                  "printable": true
                }
              ],
              "showIf": "fn(FEATURE_FLAG,Show Old QT Print)"
            },
            {
              "name": "2-printonly",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Contract Items-PrintOnly",
                  "disabled": "TRUE",
                  "items": "fetchedData.quotation.data.items",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "#",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.quotation.data.items}}))"
                    },
                    {
                      "value": "__item.product._id",
                      "text": "Item #\\n# المنتج",
                      "type": "url",
                      "url": "/products/{{__item.product._id}}"
                    },
                    {
                      "value": "__item.product.alias",
                      "text": "Description\\nالتفاصيل",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                    },
                    {
                      "value": "__item.product.unit.unit2",
                      "text": "Unit\\nالوحدة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,baseUnit,{{__item.product}})"
                    },
                    {
                      "value": "__item.productPrice.price",
                      "text": "Price\\nالسعر",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.productPrice.price}})"
                    },
                    {
                      "value": "__item.totalQuantity",
                      "text": "Quantity\\nالكمية",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.totalQuantity}},true)"
                    },
                    {
                      "value": "__item.totalFOC",
                      "text": "FOC\\nشحن مجاني",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.totalFOC}},true)",
                      "showIf": "fn(ARRAY_SUM,{{__item.totalFOC}},{{fetchedData.quotation.data.items}})"
                    },
                    {
                      "value": "__item.value",
                      "text": "Sub Total\\nالمجموع الفرعي",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.productPrice.price}},{{__item.totalQuantity}}))"
                    },
                    {
                      "value": "vatRate",
                      "text": "VAT %\\nالضريبة %",
                      "type": "formula",
                      "formula": "{{fetchedData.vatPercent}} %"
                    },
                    {
                      "value": "__item.vatValue",
                      "text": "VAT Value\\nقيمة الضريبة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,fn(MULTIPLY,{{__item.productPrice.price}},{{__item.totalQuantity}}),{{fetchedData.vatPercent}},0.01))"
                    },
                    {
                      "value": "__item.total",
                      "text": "Total + VAT\\nالمجموع + الضريبة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,fn(MULTIPLY,{{__item.productPrice.price}},{{__item.totalQuantity}}),fn(SUM,100,{{fetchedData.vatPercent}}),0.01))"
                    }
                  ],
                  "printable": true,
                  "tableType": "static",
                  "showActions": false,
                  "footer": {
                    "total": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),fn(SUM,100,{{fetchedData.vatPercent}}),0.01),{{formData.items}},product))",
                    "value": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{formData.items}},product))",
                    "vatValue": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{fetchedData.vatPercent}},0.01),{{formData.items}},product))",
                    "product.alias": "Total"
                  },
                  "fontSize": "0.75rem"
                }
              ],
              "showIf": "fn(FEATURE_FLAG,Show Old QT Print)"

            },
            {
              "name": "3-printonly",
              "pageItems": [
                {
                  "type": "custom_QtTermsCondtions",
                  "variable": "fetchedData.quotation.data",
                  "label": "Quotation Details",
                  "config": {
                    "tradeTermsListVariable": "fetchedData.tradeTermsDetails.data.0.data",
                    "paymentTermsListVariable": "fetchedData.paymentTermOptions.data.0.data"
                  },
                  "printable": true
                }
              ],
              "showIf": "fn(FEATURE_FLAG,Show Old QT Print)"
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Open')"
        }
      ],
      "useMaxPageWidth": true,
      "pageComments": {
        "commentsVariable": "formData.comments",
        "newCommentVariable": "fetchedData.commentsForm.text",
        "addComentAction": [
          {
            "executionOrder": 1,
            "name": "copyDefaultModel",
            "pageFunction": {
              "name": "copyDefaultModel",
              "type": "fnCopyData",
              "arg1Key": "sourceFn",
              "arg1Value": "getDefaultModel",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentsForm"
            }
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "addComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/quotation/{{__params.quotationId}}/add",
              "arg2Key": "postData",
              "arg2Value": "fetchedData.commentsForm",
              "arg3Key": "refreshPage",
              "arg3Value": "TRUE"
            },
            "name": "addComment"
          }
        ],
        "deleteCommentAction": [
          {
            "executionOrder": 1,
            "pageFunction": {
              "name": "copyCommentId",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item._id",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentId"
            },
            "name": "copyCommentId"
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "deleteComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/{{fetchedData.commentId}}/delete?model=quotation",
              "arg2Key": "postData",
              "arg2Value": "{}",
              "arg3Key": "requestMethod",
              "arg3Value": "DELETE",
              "arg4Key": "refreshPage",
              "arg4Value": "TRUE"
            },
            "name": "deleteComment"
          }
        ],
        "updateCommentAction": [
          {
            "executionOrder": 1,
            "pageFunction": {
              "name": "copyCommentId",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item._id",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentId"
            },
            "name": "copyCommentId"
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "copyEditCommentTextForm",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item",
              "arg2Key": "sourceFn",
              "arg2Value": "getEditCommentTextForm",
              "arg3Key": "destinationKey",
              "arg3Value": "fetchedData.editedCommentForm"
            },
            "name": "copyEditCommentTextForm"
          },
          {
            "executionOrder": 3,
            "pageFunction": {
              "name": "updateComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/{{fetchedData.commentId}}/edit",
              "arg2Key": "postData",
              "arg2Value": "fetchedData.editedCommentForm",
              "arg3Key": "requestMethod",
              "arg3Value": "PATCH",
              "arg4Key": "refreshPage",
              "arg4Value": "TRUE"
            },
            "name": "updateComment"
          }
        ]
      }
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getQuotationDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/get?id={{__params.quotationId}}&getLatest=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.quotation",
          "arg3Key": "fnsAfterSubmit",
          "arg3Value": "[{\"name\":\"copyCustomerDetails\",\"executionOrder\":1},{\"name\":\"copyQuotationData\",\"executionOrder\":1},{\"name\":\"copyInitialOrders\",\"executionOrder\":2}]"
        },
        "name": "getQuotationDetails"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "redirectToQuotationView",
          "type": "fnRedirect",
          "arg1Key": "redirectUrl",
          "arg1Value": "/quotation/{{__params.quotationId}}",
          "arg2Key": "replace",
          "arg2Value": "TRUE"
        },
        "name": "redirectToQuotationView",
        "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.quotation.data.type}},'),==,'Single')"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "redirectToScView",
          "type": "fnRedirect",
          "arg1Key": "redirectUrl",
          "arg1Value": "/view-sales-contract/{{fetchedData.quotation.data._id}}",
          "arg2Key": "replace",
          "arg2Value": "TRUE"
        },
        "name": "redirectToScView",
        "executeIf": "fn(NOT,fn(HELPER_FN,scEditFlag,{{formData.status}}))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "redirectToLatestVersion",
          "type": "fnRedirect",
          "arg1Key": "redirectUrl",
          "arg1Value": "/view-sales-contract/{{fetchedData.quotation.data._id}}",
          "arg2Key": "replace",
          "arg2Value": "TRUE"
        },
        "name": "redirectToLatestVersion",
        "executeIf": "fn(LOGICAL,{{__params.quotationId}},!=,{{fetchedData.quotation.data._id}})"
      },
      {
        "executionOrder": 3,
        "name": "getDeliveryLeadTimes",
        "pageFunction": {
          "name": "getDeliveryLeadTimes",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=leadTime",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.deliveryTime"
        }
      },
      {
        "executionOrder": 3,
        "name": "getCustomers",
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "fn(CONDITIONAL,fn(MATCH_ROLE,Sales | Account Executive),/api/v2/my-customers?showDisabled=true,/api/v2/customers?showDisabled=true)",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer"
        }
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getTradeTermDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=trade-terms",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.tradeTermsDetails"
        },
        "name": "getTradeTermDetails"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getPaymentTerms",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=payment-terms",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.paymentTermOptions"
        },
        "name": "getPaymentTerms"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getRejectionReasons",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=quotation-rejection-reasons",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.qtRejectionReasons"
        },
        "name": "getRejectionReasons"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyProductsForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultProductForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.productForm"
        },
        "name": "copyProductsForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToProductForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "formData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.productForm.q.customer"
        },
        "name": "pushCustomerIdToProductForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getProducts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/product/search",
          "arg2Key": "postData",
          "arg2Value": "fetchedData.productForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.products"
        },
        "name": "getProducts"
      },
      {
        "executionOrder": 4,
        "name": "createCurrentProductsArray"
      },
      {
        "executionOrder": 4,
        "name": "copyFilteredProducts"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "copyVatPercentage",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getVatPercentage",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyVatPercentage"
      },
      {
        "executionOrder": 5,
        "pageFunction": {
          "name": "copyInitialFormData",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "formData",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.initialFormData"
        },
        "name": "copyInitialFormData"
      }
    ],
    "functions": [
      {
        "name": "copyCustomerDetails",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getCustomerDetails",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getCustomerDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "selectedCustomer": "fetchedData.quotation.data.customer",
          "selectedContact": "fetchedData.quotation.data.contact.firstName",
          "contact": "fetchedData.quotation.data.customer.contactDetails"
        }
      },
      {
        "name": "copyQuotationData",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getQuotationData",
        "arg2Key": "destinationKey",
        "arg2Value": "formData"
      },
      {
        "name": "getQuotationData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "type": "fetchedData.quotation.data.type",
          "parent": "fetchedData.quotation.data._id",
          "updatedAt": "fetchedData.quotation.data.updatedAt",
          "createdAt": "fetchedData.quotation.data.createdAt",
          "customer": "fetchedData.quotation.data.customer._id",
          "createdBy": "fetchedData.quotation.data.createdBy",
          "status": "fetchedData.quotation.data.status",
          "dateCreated": "fetchedData.quotation.data.dateCreated",
          "comments": "fetchedData.quotation.data.comments",
          "updates": "fetchedData.quotation.data.updates",
          "isLatest": "fetchedData.quotation.data.isLatest",
          "priceBracketOnly": "fetchedData.quotation.data.priceBracketOnly",
          "version": "fetchedData.quotation.data.version",
          "contact": "fetchedData.quotation.data.contact",
          "items": "fetchedData.quotation.data.items",
          "dateRange": "fetchedData.quotation.data.dateRange",
          "deliveryLocations": "fetchedData.quotation.data.deliveryLocations",
          "uploadedProof": "fetchedData.quotation.data.uploadedProof",
          "customerPO": "fetchedData.quotation.data.customerPO",
          "termsAndConditions": "fetchedData.quotation.data.termsAndConditions",
          "info": "fetchedData.quotation.data.info"
        }
      },
      {
        "name": "findSelectedProductDetails",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.products.data.docs",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.selectedProduct"
      },
      {
        "name": "transformProductForTable",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "{{__selectedObject._id}}",
          "productPrice": "{}"
        },
        "useFormula": true
      },
      {
        "name": "printQuotation",
        "type": "fnPrint"
      },
      {
        "name": "updatePrintQuotation",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/quotation/{{__params.quotationId}}/print",
        "arg2Key": "fnsAfterSubmit",
        "arg2Value": "[{\"name\":\"printQuotation\",\"executionOrder\":1}]"
      },
      {
        "name": "copyUpdatedPrice",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getUpdatedPrice",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedPrice"
      },
      {
        "name": "copySubmittedResponse",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__response.data",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.orders",
        "arg3Key": "destinationKeyIndex",
        "arg3Value": "{{fetchedData.selectedIndex}}.productPrice",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object",
        "arg5Key": "append",
        "arg5Value": "TRUE"
      },
      {
        "name": "getUpdatedPrice",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "price": "{{fetchedData.selectedOrder.productPrice.price}}"
        },
        "useFormula": true
      },
      {
        "name": "getRejectReason",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "reason": "{{fetchedData.rejectionReason}}"
        },
        "useFormula": true
      },
      {
        "name": "getSubmitOrderForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "orders": "[]"
        },
        "useFormula": true
      },
      {
        "name": "retrieveDeliveryDate",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "deliveryDate": "__selectedObject.deliveryDate",
          "additionalCharges": "__selectedObject.additionalCharges",
          "additionalChargesType": "__selectedObject.additionalChargesType",
          "customerPO": "__selectedObject.customerPO"
        }
      },
      {
        "name": "getOrderId",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "fn(NUMBER,{{__selectedObject.order._id}})"
        },
        "useFormula": true
      },
      {
        "name": "copyInitialOrders",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "formData.items",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.orders"
      },
      {
        "name": "createCurrentProductsArray",
        "type": "fnCreateArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "formData.items",
        "arg2Key": "destinationVariable",
        "arg2Value": "formData.items",
        "arg3Key": "arrayTransformationFn",
        "arg3Value": "convertCurrentOrders"
      },
      {
        "name": "retrieveId",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "fn(NUMBER,{{__selectedObject.product._id}})"
        },
        "useFormula": true
      },
      {
        "name": "getVatPercentage",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "vatPercent": "fn(CONDITIONAL,{{fetchedData.selectedCustomer.exportCustomer}},0,{{fetchedData.companyDetails.data.0.data.vatPercentage}})"
        },
        "useFormula": true
      },
      {
        "name": "closePoProofPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Upload Proof"
      },
      {
        "name": "openSalesDashboard",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/sales-dashboard"
      },
      {
        "name": "copyFilteredProducts",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getFilteredProducts",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getFilteredProducts",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "filteredProducts": "fn(HELPER_FN,filterProducts,{{fetchedData.products.data.docs}},{{formData.items}})"
        },
        "useFormula": true
      },
      {
        "name": "getSelectedItem",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.products.data.docs",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.selectedOrder.product"
      },
      {
        "name": "getSelectedOrder",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "formData.items",
        "arg2Key": "searchKey",
        "arg2Value": "product",
        "arg3Key": "searchValue",
        "arg3Value": "__selectedObject._id"
      },
      {
        "name": "getTransformedContractItem",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "{{__selectedObject.product}}",
          "productPrice": "{{__selectedObject.productPrice}}",
          "totalQuantity": "{{__selectedObject.totalQuantity}}",
          "totalFOC": "fn(CONDITIONAL,fn(LOGICAL,{{__selectedObject.totalFOC}},>,0),{{__selectedObject.totalFOC}},0)"
        },
        "useFormula": true
      },
      {
        "name": "convertCurrentOrders",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "{{__selectedObject.product._id}}",
          "productPrice": "fn(CONDITIONAL,fn(LOGICAL,{{__selectedObject.productPrice.price}},>,-1),{{__selectedObject.productPrice}},{})",
          "totalQuantity": "{{__selectedObject.totalQuantity}}",
          "totalFOC": "fn(CONDITIONAL,fn(LOGICAL,{{__selectedObject.totalFOC}},>,0),{{__selectedObject.totalFOC}},0)"
        },
        "useFormula": true
      },
      {
        "name": "getEditCommentTextForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "text": "__item.text",
          "model": "__item.targetModel"
        }
      },
      {
        "name": "getDefaultModel",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "model": "quotation",
          "text": "{{fetchedData.commentsForm.text}}"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultProductForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": {
            "status": ["Draft", "Pending", "Open" ]
          },
          "page": 1
        },
        "staticObject": true
      },
      {
        "name": "getContractStartEndDates",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "startDate": "fn(HELPER_FN,dateFormat,{{TODAYS_DATE}},date-picker)",
          "endDate": "fn(HELPER_FN,dateFormat,fn(ADD_DAYS,{{TODAYS_DATE}},{{fetchedData.quotation.data.termsAndConditions.contractDuration}}),date-picker)"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,ACCOUNTING_COSTING,GENERAL_MANAGER,QA_MANAGER,CUSTOMER_SERVICE_MANAGER",
  "visible": false
}
